import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Text,
  Dropdown,
  DropdownMenuItem,
  Cell,
  DropdownToggleIcon
} from '../../../../../components';

const StyledTrigger = styled(Cell)`
  gap: 4px;
  cursor: pointer;
  &:hover {
    background-color: transparent !important;
  }
`;

const RoleManagementCellRenderer = (params) => {
  const { data, currentUserRole, roles, onUpdateUserEntitlement } = params;
  if (!data) return null;

  const userRole = data.memberships?.[0]?.entitlements?.[0]?.role;
  const roleNames = data.memberships?.[0]?.entitlements
    ?.map(({ role: { name } }) => name)
    .join(', ');

  if (currentUserRole === 'Admin') {
    return (
      <Dropdown
        menuPlacement='bottom-start'
        isNested
        toggleComponent={
          <StyledTrigger>
            <Text>{roleNames}</Text>
            <DropdownToggleIcon name='chevron-down' displaySize={16} color='var(--content-body)' />
          </StyledTrigger>
        }
      >
        {(closeMenu) =>
          roles.map((role) => (
            <DropdownMenuItem
              key={role.id}
              disabled={role?.id === userRole?.id}
              shouldCloseMenu={false}
              onMouseDown={(e) => {
                e.preventDefault();
                if (onUpdateUserEntitlement) {
                  onUpdateUserEntitlement(data, role);
                }
                closeMenu();
              }}
            >
              {role.name}
            </DropdownMenuItem>
          ))
        }
      </Dropdown>
    );
  }

  return <Text $bold>{roleNames}</Text>;
};

// ag-grid passes all props as a single params object
RoleManagementCellRenderer.propTypes = PropTypes.object;

export { RoleManagementCellRenderer };
